import moment from 'moment'

export default function validateExpertCertificates (certificates = [], examEndedAt) {
  if (!certificates.length || !examEndedAt) {
    return false
  }
  const isValidCertificate = certificates.some(i => moment(examEndedAt).isBetween(i.issued_at, i.expired_at))
  return isValidCertificate
}
